import React from 'react'
import { NOTIFICATION_STATUS } from './../utils/constants';

const NotiTag = (props) => {
    let type = props.type;
    let name = "";
    let style = "";
    switch (type) {
        case NOTIFICATION_STATUS.INCOMING:
            name = "Văn bản nội bộ đến";
            style = "text-[#389E0D] bg-[#F6FFED] border-[#389E0D]";
            break;
        case NOTIFICATION_STATUS.OUTGOING:
            name = "Văn bản nội bộ đi";
            style = "text-[#389E0D] bg-[#F6FFED] border-[#389E0D]";
            break;
        case NOTIFICATION_STATUS.TASK:
            name = "Nhiệm vụ";
            style = "text-[#531DAB] bg-[#D3ADF7] border-[#531DAB]";
            break;
        case NOTIFICATION_STATUS.WORK:
            name = "Công việc";
            style = "text-[#D46B08] bg-[#FFF7E6] border-[#D46B08]";
            break;
        case NOTIFICATION_STATUS.WORK_SCHEDULE:
            name = "Lịch cơ quan";
            style = "text-[#999300] bg-[#FFFEF2] border-[#999300]";
            break;
        case NOTIFICATION_STATUS.BUSINESS_TRIP:
            name = "Hành chính";
            style = "text-[#08979C] bg-[#E6FFFB] border-[#08979C]";
            break;
        case NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING:
            name = "Tin nhắn";
            style = "text-[#0075FF] bg-[#F8F8F8] border-[#0075FF]";
            break;
        default:
            name = type;
    }
    return (
        <button className={`text-[10px] font-[600] rounded px-[8px] border-[1px] ${style}`}>
            {name}
        </button>
    )
}


export default NotiTag;
